























































































import { defineComponent, reactive, toRefs } from '@vue/composition-api'
import { Message } from 'element-ui'
import $http from '@/api'
import { stringToObj, ObjToString, generateKey } from './utils'
import FormTitle from '@/components/form-title/index.vue'
export default defineComponent({
  name: 'Page',
  components: {
    FormTitle
  },
  setup(props, { root }) {
    const state = reactive({
      info: {
        appId: '',
        appSecret: '',
        ssoPage: []
      },
      appSecretDisplay: '',
      appSecretShowed: false
    })
    const onCopy = () => {
      Message.success('复制成功')
    }
    const getInfo = async () => {
      const appId = root.$route.params.id || ''
      const { errNo = -1, data = {} } = await $http.getConfigInfo({ appId })
      if (errNo === 0) {
        state.info = data
        // @ts-expect-error I see
        state.info.ssoPage = stringToObj(state.info.ssoPage)
        changeAppSecret(false)
      }
    }
    const changeAppSecret = (show = false) => {
      if (!show) {
        const appSecret = state.info.appSecret
        state.appSecretDisplay =
          appSecret.substr(0, 4) + '**** ****' + appSecret.substr(-4)
      } else {
        state.appSecretDisplay = state.info.appSecret
      }
      state.appSecretShowed = show
    }
    const moveItem = (index: number) => {
      state.info.ssoPage.splice(index, 1)
    }
    const addItem = () => {
      const data = { edit: true, value: '', key: generateKey() }
      // @ts-expect-error I see
      state.info.ssoPage.push(data)
    }
    const submit = async () => {
      const ssoPage = ObjToString(state.info.ssoPage)
      if (!ssoPage.length) {
        Message.warning('请填写SSO登录回调地址')
        return
      }
      const params = {
        appId: root.$route.params.id || '',
        ssoPage
      }
      const { errNo = -1 } = await $http.updateSsoPage(params)
      if (errNo === 0) {
        getInfo()
      }
    }
    getInfo()
    return {
      ...toRefs(state),
      onCopy,
      moveItem,
      addItem,
      submit,
      changeAppSecret
    }
  }
})
